import { graphqlClient } from "../../../client";
import getPsInFoodProductDocument from "./getPsInFoodProduct.graphql";
import type { ProductSearchResultType, Query, GetPsInFoodProductQueryVariables } from "@/core/api/graphql/types";

export async function getPsInFoodProduct(ean: string, take: number): Promise<ProductSearchResultType | null> {
  const { data } = await graphqlClient.query<Required<Pick<Query, "ps_products">>, GetPsInFoodProductQueryVariables>({
    query: getPsInFoodProductDocument,
    variables: {
      ean,
      take,
    },
  });

  return data.ps_products;
}
